/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Extras script.
 *
 * @author Rafael Agostini <me@rafaelagostini.com>
 * @author Egzon Qukovci <egzon@habtium.com>
 */

/*
 * Basics.
 */
$(document).ready(function () {
    if ($("#hinfo-site")[0] != undefined) hinfo_init();
    if ($("#hcreator-site")[0] != undefined) hcreator_init();
});

$(document).ready(function () {
    if ($("#hcreator-site-origin")[0] != undefined) hcreator_init_origin();
});

function addn(n) {
    return n < 10 ? "0" + n : "" + n;
}
function escapeHTMLEncode(str) {
    var div = document.createElement("div");
    var text = document.createTextNode(str);
    div.appendChild(text);
    return div.innerHTML;
}

/*
 * Habbo Info.
 */
function hinfo_init() {
    console.debug("Hinfo loaded");
    hinfo_validation_fields();
    searchUser();
}

function hinfo_validation_fields() {
    var $submit = $("#load-tools-button");
    $submit.attr("disabled", "disabled");

    $("#input-identifier").bind(
        "change keyup keydown mouseover click",
        function () {
            if ($(this).val().length > 0) $submit.removeAttr("disabled");
            else $submit.attr("disabled", "disabled");
        }
    );
}

var user;
function HabboUser(name, hotel, ready) {
    var self = this;
    var notfound = false;

    /* Initialization */
    api("/public/users?name=" + name, function (data) {
        if (data) {
            if (!data.uniqueId || data.profileVisible == 0) {
                self.info = data;
                ready();
            } else
                api(
                    "/public/users/" + data.uniqueId + "/profile",
                    function (data) {
                        self.info = data || false;
                        ready();
                    }
                );
        } else {
            self.info = false;
            ready();
        }
    });

    /* Api */
    function api(url, data) {
        $.getJSON("https://www.habbo." + hotel + "/api" + url, data).fail(
            function (jqXHR) {
                if (jqXHR.status == 404) {
                    notfound = true;
                    ready();
                }
            }
        );
    }

    /* Methods */
    this.checkStatus = function () {
        if (notfound == true) {
            return (
                "El usuario " +
                escapeHTMLEncode($("#input-identifier").val()) +
                " no se encuentra en este hotel"
            );
        } else {
            return null;
        }
    };

    this.getData = function (attribute) {
        if (attribute === "profileVisible" && this.info.profileVisible == 0) {
            return false;
        }
        if (!this.info[attribute]) {
            return escapeHTMLEncode(this.info.user[attribute]);
        } else {
            return escapeHTMLEncode(this.info[attribute]);
        }
    };

    this.getDataCount = function (countattribute) {
        if (
            !this.info[countattribute] ||
            (countattribute === "selectedBadges" && !this.info[countattribute])
        ) {
            return this.info.user[countattribute].length;
        } else {
            return this.info[countattribute].length;
        }
    };

    this.getDataInner = function (innerattribute) {
        var i;
        if (this.info[innerattribute]) {
            if (innerattribute === "badges") {
                innerattrbadge = this.info[innerattribute];
                innerattrbadge.sort(function (x, y) {
                    return x.code == y.code ? 0 : x.code > y.code ? 1 : -1;
                });
                var innerbadges = "";
                for (i in innerattrbadge) {
                    innerbadges +=
                        "<div class='button grey hinfo_badges' rel='tooltip' data-name='" +
                        escapeHTMLEncode(innerattrbadge[i].name) +
                        "' data-description='" +
                        escapeHTMLEncode(innerattrbadge[i].description) +
                        "' style='background-image:url(https://images.habbo.com/c_images/album1584/" +
                        escapeHTMLEncode(innerattrbadge[i].code) +
                        ".gif'></div>";
                }
                return innerbadges;
            }
            if (innerattribute === "friends") {
                innerattrfriend = this.info[innerattribute];
                var innerfriends = "";
                for (i in innerattrfriend) {
                    if (
                        innerattrfriend[i].motto == null ||
                        innerattrfriend[i].motto == undefined
                    ) {
                        innerattrfriend[i].motto == "";
                    }
                    innerfriends +=
                        "<div class='button-group hinfo_friends_group'><div class='button grey active hinfo_friends' style='background-image:url(https://www.habbo.com/habbo-imaging/avatarimage?figure=" +
                        escapeHTMLEncode(innerattrfriend[i].figureString) +
                        "&headonly=1)'></div><div class='button hinfo_friends'><span><b><a href='https://www.habbo." +
                        $("#input-hotel").val() +
                        "/profile/" +
                        escapeHTMLEncode(innerattrfriend[i].name) +
                        "' target='_blank'>" +
                        escapeHTMLEncode(innerattrfriend[i].name) +
                        "</a></b></span><span>" +
                        escapeHTMLEncode(innerattrfriend[i].motto) +
                        "</span></div></div>";
                }
                return innerfriends;
            }
            if (innerattribute === "groups") {
                innerattrgroup = this.info[innerattribute];
                var innergroups = "";
                for (i in innerattrgroup) {
                    if (
                        innerattrgroup[i].primaryColour == undefined ||
                        innerattrgroup[i].primaryColour == null
                    ) {
                        innerattrgroup[i].primaryColour = "FFF";
                    }
                    if (
                        innerattrgroup[i].secondaryColour == undefined ||
                        innerattrgroup[i].secondaryColour == null
                    ) {
                        innerattrgroup[i].secondaryColour = "FFF";
                    }
                    if (innerattrgroup[i].type == "CLOSED") {
                        innerattrgroup[i].type =
                            "<i class='hinfo_closedg glyphicons glyphicons-lock'></i> ";
                    } else if (innerattrgroup[i].type == "EXCLUSIVE") {
                        innerattrgroup[i].type =
                            "<i class='hinfo_excluvg glyphicons glyphicons-keys'></i> ";
                    } else {
                        innerattrgroup[i].type = "";
                    }
                    if (innerattrgroup[i].isAdmin == true) {
                        innerattrgroup[i].isAdmin =
                            "<i class='hinfo_admingroup glyphicons glyphicons-star'></i>";
                    } else {
                        innerattrgroup[i].isAdmin = "";
                    }
                    innergroups +=
                        "<div class='button-group hinfo_groups_group'><div class='button grey active hinfo_groups' style='background-image:url(https://www.habbo.com/habbo-imaging/badge/" +
                        escapeHTMLEncode(innerattrgroup[i].badgeCode) +
                        ".gif)'><div class='button-group hinfo_groups_colors'><span class='button' style='background-color:#" +
                        escapeHTMLEncode(innerattrgroup[i].primaryColour) +
                        ";'></span><span class='button' style='background-color:#" +
                        escapeHTMLEncode(innerattrgroup[i].secondaryColour) +
                        ";'></span></div></div><div class='button hinfo_groups'>" +
                        innerattrgroup[i].isAdmin +
                        "<span>" +
                        innerattrgroup[i].type +
                        " <a href='https://www.habbo." +
                        escapeHTMLEncode($("#input-hotel").val()) +
                        "/hotel?room=" +
                        escapeHTMLEncode(innerattrgroup[i].roomId) +
                        "' target='_blank'><b>" +
                        escapeHTMLEncode(innerattrgroup[i].name) +
                        "</b></a></span><span>" +
                        escapeHTMLEncode(innerattrgroup[i].description) +
                        "</span></div></div>";
                }
                return innergroups;
            }
            if (innerattribute === "rooms") {
                innerattrroom = this.info[innerattribute];
                innerattrroom.sort(function (x, y) {
                    return x.name == y.name ? 0 : x.name > y.name ? 1 : -1;
                });
                var innerrooms = "";
                for (i in innerattrroom) {
                    if (
                        innerattrroom[i].description == null ||
                        innerattrroom[i].description == undefined
                    ) {
                        innerattrroom[i].description = "";
                    }
                    innerrooms +=
                        "<div class='button-group hinfo_rooms_group'><div class='button grey active hinfo_rooms' style='background-image:url(" +
                        escapeHTMLEncode(innerattrroom[i].thumbnailUrl) +
                        "), url(/images/room_noimg.png)'><div class='button-group hinfo_rooms_misc'><span class='button green active'><i class='glyphicons glyphicons-thumbs-up'></i> " +
                        escapeHTMLEncode(innerattrroom[i].rating) +
                        "</span><span class='button red active'><i class='glyphicons glyphicons-user'></i> " +
                        escapeHTMLEncode(innerattrroom[i].maximumVisitors) +
                        "</span></div></div><div class='button hinfo_rooms'><span><a href='https://www.habbo." +
                        escapeHTMLEncode($("#input-hotel").val()) +
                        "/hotel?room=" +
                        escapeHTMLEncode(innerattrroom[i].id) +
                        "' target='_blank'><b>" +
                        escapeHTMLEncode(innerattrroom[i].name) +
                        "</b></a></span><span>" +
                        escapeHTMLEncode(innerattrroom[i].description) +
                        "</span></div></div>";
                }
                return innerrooms;
            }
            if (
                innerattribute === "selectedBadges" &&
                this.info[innerattribute]
            ) {
                innerattrselbadge = this.info[innerattribute];
                var innerselbadges = "";
                for (i in innerattrselbadge) {
                    innerselbadges +=
                        "<div class='button grey hinfo_badges' rel='tooltip' data-name='" +
                        escapeHTMLEncode(innerattrselbadge[i].name) +
                        "' data-description='" +
                        escapeHTMLEncode(innerattrselbadge[i].description) +
                        "' style='background-image:url(https://images.habbo.com/c_images/album1584/" +
                        escapeHTMLEncode(innerattrselbadge[i].code) +
                        ".gif'></div>";
                }
                return innerselbadges;
            }
        } else if (
            innerattribute === "selectedBadges" &&
            !this.info[innerattribute]
        ) {
            innerattrselbadge = this.info.user[innerattribute];
            var innerselbadges = "";
            for (i in innerattrselbadge) {
                innerselbadges +=
                    "<div class='button grey hinfo_badges' rel='tooltip' data-name='" +
                    escapeHTMLEncode(innerattrselbadge[i].name) +
                    "' data-description='" +
                    escapeHTMLEncode(innerattrselbadge[i].description) +
                    "' style='background-image:url(https://images.habbo.com/c_images/album1584/" +
                    escapeHTMLEncode(innerattrselbadge[i].code) +
                    ".gif'></div>";
            }
            return innerselbadges;
        } else {
            return false;
        }
    };
}
function searchUser() {
    $("#load-tools-button").click(function () {
        $("#load-tools-response").html(
            '<div class="box box-big"><div class="body"><center><div class="img-ajax-loader"><img src="/images/loading.gif" class="img-ajax-loader" /></div></center></div></div>'
        );
        user = new HabboUser(
            escapeHTMLEncode($("#input-identifier").val()),
            escapeHTMLEncode($("#input-hotel").val()),
            function () {
                $("#hinfo-site > #load-tools-response").html(
                    '<div class="box box-big"><div id="hinfo-body" class="body"></div></div>'
                );
                var databody = $("#hinfo-body.body");
                var stringdata = "";
                if (user.checkStatus() != null) {
                    databody.html(
                        '<div class="button grey big" style="text-align:center;width:100%;">' +
                            user.checkStatus() +
                            "</div>"
                    );
                    console.error("Status: " + user.checkStatus());
                } else {
                    var mdate = new Date(user.getData("memberSince"));
                    var memberdate =
                        addn(mdate.getDate()) +
                        "/" +
                        addn(mdate.getMonth() + 1) +
                        "/" +
                        mdate.getFullYear() +
                        " " +
                        addn(mdate.getHours()) +
                        ":" +
                        addn(mdate.getMinutes()) +
                        ":" +
                        addn(mdate.getSeconds());
                    var summarydata = "";
                    summarydata +=
                        '<div id="hinfo-summary" class="button-group body">';
                    summarydata +=
                        '<div class="hinfo_summary button grey active" style="background-image:url(https://www.habbo.com/habbo-imaging/avatarimage?figure=' +
                        user.getData("figureString") +
                        ')"></div>';
                    summarydata += '<div class="hinfo_summary button">';
                    summarydata +=
                        "<span><b>ID</b>: " +
                        user.getData("uniqueId") +
                        "</span>";
                    summarydata +=
                        '<span><b>Nombre</b>: <a href="https://www.habbo.' +
                        escapeHTMLEncode($("#input-hotel").val()) +
                        "/profile/" +
                        user.getData("name") +
                        '" target="_blank"><b>' +
                        user.getData("name") +
                        "</b></a></span>";
                    summarydata +=
                        "<span><b>Misión</b>: " +
                        user.getData("motto") +
                        "</span>";
                    summarydata +=
                        "<span><b>Fecha de creación</b>: " +
                        memberdate +
                        "</span>";
                    if (user.getDataCount("selectedBadges") == 0) {
                        summarydata +=
                            '<div class="hinfo_summary_badges button grey big">Este usuario no tiene placas seleccionadas</div>';
                    } else {
                        summarydata +=
                            '<div class="hinfo_summary_badges button-group">' +
                            user.getDataInner("selectedBadges") +
                            "</div>";
                    }
                    summarydata += "</div>";
                    summarydata += "</div>";
                    stringdata += summarydata;
                    if (user.getData("profileVisible") == 0) {
                        stringdata +=
                            '<div class="button grey big">No podemos acceder a las placas, los amigos, las salas y los grupos de este usuario porque su perfil está cerrado.</div>';
                    } else {
                        var hinfo_toggle_array_badges = ["", ""];
                        var hinfo_toggle_array_friends = ["", ""];
                        var hinfo_toggle_array_groups = ["", ""];
                        var hinfo_toggle_array_rooms = ["", ""];
                        if (user.getDataCount("badges") >= 250) {
                            hinfo_toggle_array_badges = [
                                "style='cursor:pointer;' onclick=$('#hinfo-badges').toggle();",
                                "style='display:none;'",
                            ];
                        }
                        if (user.getDataCount("friends") >= 70) {
                            hinfo_toggle_array_friends = [
                                "style='cursor:pointer;' onclick=$('#hinfo-friends').toggle();",
                                "style='display:none;'",
                            ];
                        }
                        if (user.getDataCount("groups") >= 20) {
                            hinfo_toggle_array_groups = [
                                "style='cursor:pointer;' onclick=$('#hinfo-groups').toggle();",
                                "style='display:none;'",
                            ];
                        }
                        if (user.getDataCount("rooms") >= 10) {
                            hinfo_toggle_array_rooms = [
                                "style='cursor:pointer;' onclick=$('#hinfo-rooms').toggle();",
                                "style='display:none;'",
                            ];
                        }
                        stringdata +=
                            '<div id="hinfo-bhead" ' +
                            hinfo_toggle_array_badges[0] +
                            ' class="button orange active big">Placas (' +
                            user.getDataCount("badges") +
                            ")</div>";
                        stringdata +=
                            '<div id="hinfo-badges" ' +
                            hinfo_toggle_array_badges[1] +
                            ' class="body">' +
                            user.getDataInner("badges") +
                            "</div>";
                        stringdata +=
                            '<div id="hinfo-fhead" ' +
                            hinfo_toggle_array_friends[0] +
                            ' class="button red active big">Amigos (' +
                            user.getDataCount("friends") +
                            ")</div>";
                        stringdata +=
                            '<div id="hinfo-friends" ' +
                            hinfo_toggle_array_friends[1] +
                            ' class="body">' +
                            user.getDataInner("friends") +
                            "</div>";
                        stringdata +=
                            '<div id="hinfo-ghead" ' +
                            hinfo_toggle_array_groups[0] +
                            ' class="button green active big">Grupos (' +
                            user.getDataCount("groups") +
                            ")</div>";
                        stringdata +=
                            '<div id="hinfo-groups" ' +
                            hinfo_toggle_array_groups[1] +
                            ' class="body">' +
                            user.getDataInner("groups") +
                            "</div>";
                        stringdata +=
                            '<div id="hinfo-rhead" ' +
                            hinfo_toggle_array_rooms[0] +
                            ' class="button blue active big">Salas (' +
                            user.getDataCount("rooms") +
                            ")</div>";
                        stringdata +=
                            '<div id="hinfo-rooms" ' +
                            hinfo_toggle_array_rooms[1] +
                            ' class="body">' +
                            user.getDataInner("rooms") +
                            "</div>";
                    }
                    databody.html(stringdata);
                }
            }
        );
    });
}

/*
 * Habbo generator.
 */
function hcreator_init() {
    hcreator_generate_habbo();
}

function hcreator_generate_habbo() {
    var arrayAction = new Array(
        "",
        "wav",
        "wlk",
        "sit",
        "lay",
        "crr=1",
        "crr=2",
        "crr=3",
        "crr=4",
        "crr=5",
        "crr=6",
        "crr=9",
        "crr=33",
        "crr=44",
        "drk=1",
        "drk=2",
        "drk=3",
        "drk=4",
        "drk=5",
        "drk=6",
        "drk=9",
        "drk=33",
        "drk=44",
        "sit,crr=1",
        "sit,crr=2",
        "sit,crr=3",
        "sit,crr=4",
        "sit,crr=5",
        "sit,crr=6",
        "sit,crr=9",
        "sit,crr=33",
        "sit,crr=44",
        "sit,drk=1",
        "sit,drk=2",
        "sit,drk=3",
        "sit,drk=4",
        "sit,drk=5",
        "sit,drk=6",
        "sit,drk=9",
        "sit,drk=33",
        "sit,drk=44"
    );
    var arrayGesture = new Array("sml", "sad", "agr", "srp", "eyb", "");
    var arraySize = new Array("l", "n", "s");
    var action = 0;
    var head_direction = 3;
    var direction = 3;
    var gesture = 0;
    var size = 0;
    var habboname = "Habtium";
    var hotel = "es";

    function updateHabbo() {
        $(".habbo").attr(
            "src",
            "https://www.habbo." +
                hotel +
                "/habbo-imaging/avatarimage?user=" +
                habboname +
                "&direction=" +
                direction +
                "&head_direction=" +
                head_direction +
                "&gesture=" +
                arrayGesture[gesture] +
                "&action=" +
                arrayAction[action] +
                "&size=" +
                arraySize[size]
        );
    }

    $("#start").click(function () {
        hotel = $("#hotel").val();
        if ($("#habboname").val() !== "") {
            habboname = $("#habboname").val();
        }
        updateHabbo();
    });

    $(".right").click(function () {
        var rightRowParent = $(this).parent().attr("id");

        if (rightRowParent == "options-body") {
            direction--;
            if (direction < 1) direction = 9;
        } else if (rightRowParent == "options-head") {
            head_direction--;
            if (head_direction < 1) head_direction = 9;
        } else if (rightRowParent == "options-gesture") {
            gesture--;
            if (gesture < 0) gesture = 5;
        } else if (rightRowParent == "options-action") {
            action--;
            if (action < 0) action = arrayAction.length - 1;
        } else if (rightRowParent == "options-size") {
            size--;
            if (size < 0) size = 2;
        }

        updateHabbo();
    });

    $(".left").click(function () {
        var leftRowParent = $(this).parent().attr("id");

        if (leftRowParent == "options-body") {
            direction++;
            if (direction > 9) direction = 1;
        } else if (leftRowParent == "options-head") {
            head_direction++;
            if (head_direction > 9) head_direction = 1;
        } else if (leftRowParent == "options-gesture") {
            gesture++;
            if (gesture > 5) gesture = 0;
        } else if (leftRowParent == "options-action") {
            action++;
            if (action > arrayAction.length - 1) action = 0;
        } else if (leftRowParent == "options-size") {
            size++;
            if (size > 2) size = 0;
        }

        updateHabbo();
    });
}

function hcreator_init_origin() {
    hcreator_generate_habbo_origin();
}

function hcreator_generate_habbo_origin() {
    var arrayAction = new Array(
        "",
        "wav",
        "wlk",
        "sit",
        "lay",
        "crr=1",
        "crr=2",
        "crr=3",
        "crr=4",
        "crr=5",
        "crr=6",
        "crr=9",
        "crr=33",
        "crr=44",
        "drk=1",
        "drk=2",
        "drk=3",
        "drk=4",
        "drk=5",
        "drk=6",
        "drk=9",
        "drk=33",
        "drk=44",
        "sit,crr=1",
        "sit,crr=2",
        "sit,crr=3",
        "sit,crr=4",
        "sit,crr=5",
        "sit,crr=6",
        "sit,crr=9",
        "sit,crr=33",
        "sit,crr=44",
        "sit,drk=1",
        "sit,drk=2",
        "sit,drk=3",
        "sit,drk=4",
        "sit,drk=5",
        "sit,drk=6",
        "sit,drk=9",
        "sit,drk=33",
        "sit,drk=44"
    );
    var arrayGesture = new Array("sml", "sad", "agr", "srp", "eyb", "");
    var arraySize = new Array("n", "s");
    var action = 0;
    var head_direction = 3;
    var direction = 3;
    var gesture = 0;
    var size = 0;
    var habboname = "Habtium";
    var hotel = "es";
    let figureString =
        "hr-110-1045.hd-180-1014.ch-275-1.lg-305-1.sh-215-1.ha-0-1045";

    async function getFigureString() {
        const query = await fetch(
            `https://api.habbotools.com/v1/origins/habbo-figure?hotel=${hotel}&name=${habboname}`
        );
        const data = await query.json();
        figureString = data.data;
    }

    function updateHabbo() {
        $(".habbo").attr(
            "src",
            "https://www.habbo.com/habbo-imaging/avatarimage?figure=" +
                figureString +
                "&direction=" +
                direction +
                "&head_direction=" +
                head_direction +
                "&gesture=" +
                arrayGesture[gesture] +
                "&action=" +
                arrayAction[action] +
                "&size=" +
                arraySize[size]
        );
    }

    $("#start-origin").click(async function () {
        hotel = $("#hotel").val();
        if ($("#habboname").val() !== "") {
            habboname = $("#habboname").val();
        }
        await getFigureString();
        updateHabbo();
    });

    $(".right").click(function () {
        var rightRowParent = $(this).parent().attr("id");

        if (rightRowParent == "options-body") {
            direction--;
            if (direction < 1) direction = 9;
        } else if (rightRowParent == "options-head") {
            head_direction--;
            if (head_direction < 1) head_direction = 9;
        } else if (rightRowParent == "options-gesture") {
            gesture--;
            if (gesture < 0) gesture = 5;
        } else if (rightRowParent == "options-action") {
            action--;
            if (action < 0) action = arrayAction.length - 1;
        } else if (rightRowParent == "options-size") {
            size--;
            if (size < 0) size = 2;
        }

        updateHabbo();
    });

    $(".left").click(function () {
        var leftRowParent = $(this).parent().attr("id");

        if (leftRowParent == "options-body") {
            direction++;
            if (direction > 9) direction = 1;
        } else if (leftRowParent == "options-head") {
            head_direction++;
            if (head_direction > 9) head_direction = 1;
        } else if (leftRowParent == "options-gesture") {
            gesture++;
            if (gesture > 5) gesture = 0;
        } else if (leftRowParent == "options-action") {
            action++;
            if (action > arrayAction.length - 1) action = 0;
        } else if (leftRowParent == "options-size") {
            size++;
            if (size > 2) size = 0;
        }

        updateHabbo();
    });
}
